/**
 * Check if cache is stale based on TTL (Time To Live).
 * @param lastFetched - Timestamp when data was last fetched (in milliseconds), or null if never fetched
 * @param ttl - Time to live in milliseconds
 * @returns true if cache is stale (needs refresh), false if still valid
 */
export function isCacheStale(lastFetched: number | null, ttl: number): boolean {
  if (!lastFetched) return true;
  return Date.now() - lastFetched > ttl;
}
